module.exports = __webpack_public_path__ + "static/lahtopaikka-21e00f49bbda1b0af2c4a6ab1ea6fb24.png";